import React from 'react';
import styled, {keyframes} from 'styled-components';

export const prizeStyles: Record<string, { color: string; bg: string }> = {
    'First 5': {color: '#00C000', bg: '#34B900'},
    'Corners': {color: '#6347BF', bg: '#26126A'},
    '1st Line': {color: '#00BEED', bg: '#00576C'},
    '2nd Line': {color: '#00C8B7', bg: '#00544D'},
    '3rd Line': {color: '#FF5353', bg: '#9F1414'},
    'Full House': {color: '#FF7715', bg: '#963C00'},
    'Last Number': {color: '#E63A8A', bg: '#76001C'},
    'Fast 10': {color: '#327AE6', bg: '#26126A'},
    'Double Line': {color: '#03B97C', bg: '#005035'},
};

interface PrizeCardVisualProps {
    playerName: string;
    avatarUrl: string;
    prizeName: string;
    rank: number;
    points: number;
    onClose: () => void;
}

// Fade-in animation
const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: scale(0.8);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
`;

// 🔲 Modal overlay
const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
`;

// 🟨 The actual modal card
const CardWrapper = styled.div<{ borderColor: string }>`
    position: relative;
    width: 90%;
    max-width: 300px;
    padding: 20px;
    background: #F6FF71;
    border-radius: 30px;
    box-shadow: 0 0 0 6px ${({borderColor}) => borderColor},
    0 0 0 10px #bfcfff;
    text-align: center;
    animation: ${fadeIn} 0.3s ease-out;
`;

const Header = styled.div<{ bgColor: string }>`
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    background: ${({bgColor}) => bgColor};
    color: white;
    padding: 8px 24px;
    border-radius: 24px;
    font-weight: bold;
    font-size: 18px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    border: 3px solid white;
`;


const CloseBtn = styled.div<{ bgColor: string }>`
    position: absolute;
    top: -12px;
    right: -12px;
    background: ${({bgColor}) => bgColor};
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    font-weight: bold;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid white;
    cursor: pointer;
`;

const AvatarContainer = styled.div`
    position: relative;
    margin: 40px 0 0px;
`;

const Avatar = styled.img`
    width: 100px;
    position: relative;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
    border: 4px solid white;
`;

const RankOverlay = styled.div`
    position: absolute;
    top: 33%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 0.6rem;

    @media (min-width: 768px) {
        font-size: 0.8rem;
    }

    color: black;
    font-weight: bold;
    pointer-events: none;
`;


const Crown = styled.div`
    position: absolute;
    top: -15px;
    width: 40px;
    height: 40px;
    left: 60%;
    transform: translateX(-50%);
    font-size: 32px;
    z-index: 10;
`;

const RankBadge = styled.div`
    position: absolute;
    top: -5px;
    left: -10px;
    background: orange;
    color: white;
    font-weight: bold;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const PointsBox = styled.div<{ bgColor: string }>`
    background: white;
    padding: 8px 16px;
    margin-top: 10px;
    display: inline-flex;
    align-items: center;
    border-radius: 12px;
    font-weight: bold;
    color: black;
    font-size: 18px;
    box-shadow: 0 4px 0 ${({bgColor}) => bgColor};
    border: 2px solid #eee;
`;

const CoinIcon = styled.div`
    background: gold;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 16px;
`;

const Image = styled.div`
    width: 40px;
    height: 40px;
    position: absolute;
    left: 27%;
    top: 6%;

    @media (min-width: 768px) {
        width: 40px;
        height: 40px;
        left: 27%;
        top: 6%;

    }
`;
const PrizeWinnerModal: React.FC<PrizeCardVisualProps> = ({
                                                              playerName,
                                                              avatarUrl,
                                                              prizeName,
                                                              rank,
                                                              points,
                                                              onClose,
                                                          }) => {
    const {color, bg} = prizeStyles[prizeName] || {color: '#00C000', bg: '#06DB03'};

    return (
        <Overlay>
            <CardWrapper borderColor={bg}>
                <Header bgColor={bg}>{prizeName.toUpperCase()}</Header>

                <AvatarContainer>
                    <Crown> <img src={"./crown-1.png"} style={{height: '100%', width: '100%'}}/></Crown>
                    <Avatar src={avatarUrl} alt={playerName}/>
                    <Image>
                        <img src={"./rank.png"} style={{height: '100%', width: '100%'}}/>
                        <RankOverlay>{rank}</RankOverlay>
                    </Image>
                </AvatarContainer>
                <h1 style={{
                    fontSize: '16px',
                }}>{playerName}</h1>

                <PointsBox bgColor={bg}>
                    <CoinIcon>
                        <img src={"./coin-1.png"} style={{height: '100%', width: '100%'}}/>
                    </CoinIcon> +{points}
                </PointsBox>
            </CardWrapper>
        </Overlay>
    );
};

export default PrizeWinnerModal;
